import React, { useCallback, useMemo } from 'react';
import { ButtonProps } from '@mui/material';
import { NodonTheme } from '@client/style';
import {
  ElementSelectPropertyCountType,
  IElementPropertyOption,
} from '@shared/models/element-property.model';
import { PropertyMenu } from '@ui/menus/PropertyMenu';
import { SbefCode } from '@shared/construction/sbef.model';

interface SBEFLabelProps {
  code: SbefCode | undefined;
  menuItems?: IElementPropertyOption[];
  hidden?: boolean;
  onSelect?: (label: string) => void;
}

const SBEFLabel: React.FC<SBEFLabelProps> = ({
  code,
  menuItems = [],
  hidden = false,
  onSelect,
}) => {
  const handleSelect = useCallback(
    (value: ElementSelectPropertyCountType) => {
      if (onSelect && typeof value === 'string') {
        onSelect(value);
      }
    },
    [onSelect],
  );

  const buttonProps = useMemo<ButtonProps>(() => {
    return {
      sx: {
        opacity: hidden ? 0 : 1,
        background: NodonTheme.palette.neutral.lightest,
        padding: '2px 4px',
        marginLeft: 2,
      },
    };
  }, [hidden]);

  return (
    <PropertyMenu
      buttonProps={buttonProps}
      selectedValue={code}
      selectedLabel={code ?? '-'}
      options={menuItems}
      onSelect={handleSelect}
    />
  );
};

export default SBEFLabel;
